import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
import _createClass from "/app/node_modules/babel-runtime/helpers/createClass";
export var BossApi = function () {
    function BossApi(axios, store) {
        _classCallCheck(this, BossApi);

        this.axios = axios;
    }

    _createClass(BossApi, [{
        key: "updatePasswordBossAndAdmin",
        value: function updatePasswordBossAndAdmin(data) {
            return this.axios.$post("/boss/bosses/update-password", data);
        }
    }, {
        key: "getListOfBoss",
        value: function getListOfBoss(data) {
            return this.axios.$post("/boss/bosses/find-boss-management", data);
        }
    }, {
        key: "createdNewBoss",
        value: function createdNewBoss(data) {
            return this.axios.$post("/boss/bosses/new-boss", data);
        }
    }, {
        key: "editBoss",
        value: function editBoss(data) {
            return this.axios.$post("/boss/bosses/edit-boss", data);
        }
    }, {
        key: "findBossById",
        value: function findBossById(data) {
            return this.axios.$post("/boss/bosses/find-boss-by-id", data);
        }
    }, {
        key: "validationBossEmail",
        value: function validationBossEmail(data) {
            return this.axios.$post("/boss/bosses/validation-email", data);
        }
    }, {
        key: "validationDocumentNumberBoss",
        value: function validationDocumentNumberBoss(data) {
            return this.axios.$post("/boss/bosses/validation-document-number", data);
        }
    }, {
        key: "validationPasswordBoss",
        value: function validationPasswordBoss(data, cancelToken) {
            return this.axios.$post("/boss/bosses/validation-password", data, { cancelToken: cancelToken });
        }
    }]);

    return BossApi;
}();


//////////////////
// WEBPACK FOOTER
// ./src/api/boss.js
// module id = ./src/api/boss.js
// module chunks = 34